    import React, {useEffect} from "react";
    import './App.css';
    import Header from "./Header";
    import Home from "./Home";
    import {BrowserRouter as Router, Switch, Route} from "react-router-dom"
    import Checkout from "./Checkout";
    import Login from "./Login";
    import {auth} from "./firebase";
    import {useStateValue} from "./StateProvider";
    import Payment from './Payment';
    import {loadStripe} from "@stripe/stripe-js/pure";
    import { Elements} from "@stripe/react-stripe-js";
    import Orders from "./Orders";


    // import {Payment} from "@material-ui/icons";

    const promise = loadStripe('pk_test_51HxKqlL5Up5qX74OwoULmZaG0Nsi4eGj4ZL7E9gxsdHp48EczspPBBCldHOSlbm92AyZsEZbaBkJ3NVwIDCQoeA9003D9V7iuZ');

    function App() {

      const [{}, dispatch] = useStateValue()
      useEffect(()=>{
          //will only run once when the app component loads...
          auth.onAuthStateChanged(authUser =>{
              console.log('THE USER IS >>>',authUser);

              if (authUser) {
                  //the user just logged in/ the user was logged in
                  dispatch({
                      type: 'SET_USER',
                      user: authUser
                  })

              } else {    //the user is logged out
                  dispatch({
                      type: 'SET_USER',
                      user:null

                  })
              }
          })
      },[])

      return (
        // BEM
       <Router>
        <div className="App">

            {/*<Header />*/}
            <Switch>
                <Route path='/orders'>
                    <Header />
                    <Orders/>
                </Route>
                <Route path='/login'>
                    <Login/>
                </Route>
                <Route path="/checkout">
                    <Header />
                    <Checkout/>
                </Route>
                <Route path="/payment">
                    <Header />
                    <Elements stripe={promise}>
                    <Payment/>
                    </Elements>
                </Route>
                <Route path="/">
                      <Header />
                    <Home />
                </Route>
            </Switch>
            {/* Home */}
        </div>
       </Router>
      );
    }

    export default App;


